module.exports = __webpack_public_path__ + "img/icon_rucksacke.6abcdc8c.svg";